import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  server: {
    CMS_APPLICATION_BEARER_TOKEN: z.string(),
    CORS_ALLOWED_ORIGINS: z.string(),
  },

  client: {
    NEXT_PUBLIC_API_BASE_URL: z.string().url(),
    NEXT_PUBLIC_CMS_API_BASE_URL: z.string().url(),
    NEXT_PUBLIC_ZAMP_API_BASE_URL: z.string().url(),
    NEXT_PUBLIC_APPLICATION_BASE_URL: z.string().url(),
    NEXT_PUBLIC_GOOGLE_PLAY_DOWNLOAD_APP_URL: z.string().url(),
    NEXT_PUBLIC_APPLE_STORE_DOWNLOAD_APP_URL: z.string().url(),
    NEXT_PUBLIC_IFOOD_REDIRECT_URL: z.string().url(),
    NEXT_PUBLIC_RAPPI_REDIRECT_URL: z.string().url(),
    NEXT_PUBLIC_GRAPHQL_BASE_URL: z.string().url(),
    NEXT_PUBLIC_GRAPHQL_X_API_KEY: z.string(),
    NEXT_PUBLIC_GOOGLE_CLIENT_ID: z.string(),
    NEXT_PUBLIC_GOOGLE_REDIRECT_URI: z.string().url(),
    NEXT_PUBLIC_GTM_ID: z.string(),
    NEXT_PUBLIC_NUTRITION_TABLE_URL: z.string().url(),

    NEXT_PUBLIC_DYNATRACE_ENABLED: z
      .enum(['true', 'false'])
      .optional()
      .default('false')
      .transform((value) => value === 'true'),
  },

  runtimeEnv: {
    CMS_APPLICATION_BEARER_TOKEN: process.env.CMS_APPLICATION_BEARER_TOKEN,
    CORS_ALLOWED_ORIGINS: process.env.CORS_ALLOWED_ORIGINS,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_CMS_API_BASE_URL: process.env.NEXT_PUBLIC_CMS_API_BASE_URL,
    NEXT_PUBLIC_ZAMP_API_BASE_URL: process.env.NEXT_PUBLIC_ZAMP_API_BASE_URL,
    NEXT_PUBLIC_APPLICATION_BASE_URL:
      process.env.NEXT_PUBLIC_APPLICATION_BASE_URL,
    NEXT_PUBLIC_GOOGLE_PLAY_DOWNLOAD_APP_URL:
      process.env.NEXT_PUBLIC_GOOGLE_PLAY_DOWNLOAD_APP_URL,
    NEXT_PUBLIC_APPLE_STORE_DOWNLOAD_APP_URL:
      process.env.NEXT_PUBLIC_APPLE_STORE_DOWNLOAD_APP_URL,
    NEXT_PUBLIC_IFOOD_REDIRECT_URL: process.env.NEXT_PUBLIC_IFOOD_REDIRECT_URL,
    NEXT_PUBLIC_RAPPI_REDIRECT_URL: process.env.NEXT_PUBLIC_RAPPI_REDIRECT_URL,
    NEXT_PUBLIC_GRAPHQL_BASE_URL: process.env.NEXT_PUBLIC_GRAPHQL_BASE_URL,
    NEXT_PUBLIC_GRAPHQL_X_API_KEY: process.env.NEXT_PUBLIC_GRAPHQL_X_API_KEY,
    NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
    NEXT_PUBLIC_GOOGLE_REDIRECT_URI:
      process.env.NEXT_PUBLIC_GOOGLE_REDIRECT_URI,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    NEXT_PUBLIC_NUTRITION_TABLE_URL:
      process.env.NEXT_PUBLIC_NUTRITION_TABLE_URL,
    NEXT_PUBLIC_DYNATRACE_ENABLED: process.env.NEXT_PUBLIC_DYNATRACE_ENABLED,
  },
})
